import React from "react";
import {useTranslation} from "@unibuddy/intl";
import WarningIconWithOutline from "shared/Experimental/Icons/WarningIconWithOutline";
import {Box, Button, Text} from "@unibuddy/patron";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_SHARE_PERSONAL_DETAILS_WARNING} from "../../../../../translations/inbox";

export const SensitiveDataWarningPopUp = ({onCloseClick}: {onCloseClick: () => void}) => {
    const {t} = useTranslation(IntlNamespaces.INBOX);

    const CloseButton = ({onClick}: {onClick: () => void}) => (
        <Button
            size="sm"
            round
            clear
            iconOnly
            aria-label={"Close Sensitive Data Warning Pop Up"}
            onClick={onClick}
        >
            X
        </Button>
    );

    return (
        <Box
            bgColor="#FEE8CD"
            display="flex"
            paddingBottom="medium"
            paddingLeft="small"
            gap="small"
        >
            <Box display="flex" paddingTop="medium" gap="small">
                <Box flexShrink={0}>
                    <WarningIconWithOutline color="#834901" />
                </Box>
                <Text color="#834901">
                    {t(
                        INTL_SHARE_PERSONAL_DETAILS_WARNING.key,
                        INTL_SHARE_PERSONAL_DETAILS_WARNING.defaultValue,
                    )}
                </Text>
            </Box>
            <Box id="close-button-container" padding={"xxsmall"} flexShrink={0}>
                <CloseButton onClick={onCloseClick} />
            </Box>
        </Box>
    );
};
